<template>
  <v-container fluid>
    <v-row v-if="isLoading">
      <v-col>
        <loading-spinner></loading-spinner>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" md="6">
        <v-card>
          <v-tabs v-model="currentTab" align-tabs="start" color="primary">
            <v-tab v-for="item in tabs" :key="item.id" @click="onSelect(item)">
              {{ item.label }}
            </v-tab>
          </v-tabs>
          <v-card-text>
            <paginated-table-content
              :columns="tableColumns"
              :data="templates"
              @updatePagination="updatePagination"
            ></paginated-table-content>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <editor-card :value="template.content" @update-content="updateContent">
          <template v-slot:header>
            <v-row align="center">
              <v-col cols="8">
                <v-text-field
                  v-model="template.title"
                  :label="$t('label.title')"
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="template.code"
                  :label="$t('label.code')"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-slot:bottom-buttons>
            <v-card-actions class="mt-3">
              <v-spacer></v-spacer>
              <custom-button
                @click="handleSubmit"
                :label="$t('button.save')"
                color="primary"
                size="lg"
                gradient
                rounded
              ></custom-button>
            </v-card-actions>
          </template>
        </editor-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PaginatedTableContent from "@/components/common/Tables/PaginatedTableContent.vue";
import EditorCard from "@/components/common/Cards/EditorCard.vue";
import LoadingSpinner from "@/components/common/Spinners/LoadingSpinner.vue";
import CustomButton from "@/components/common/buttons/CustomButton.vue";

import { tabs } from "@/views/MailtemplateView/tabs";
import { savePopup, success } from "@/views/MailtemplateView/popups";
import { getMailtemplateColumns } from "@/views/MailtemplateView/columns";
import { mailtemplateApi } from "@/api/api";

export default {
  components: {
    EditorCard,
    CustomButton,
    PaginatedTableContent,
    LoadingSpinner,
  },
  data() {
    return {
      isLoading: false,
      tabs: tabs,
      tableColumns: getMailtemplateColumns({
        edit: this.handleEdit,
      }),
      currentTab: tabs[0],
      templates: {
        page_info: { page: 1, size: 5, total_elements: 5, total_pages: 1 },
        elements: [],
      },
      template: {
        idx: null,
        title: null,
        content: null,
        code: null,
      },
    };
  },
  methods: {
    async fetchMailtemplates(size, page, category) {
      this.isLoading = true;
      try {
        const params = { category_code: category, size, page };
        const response = await mailtemplateApi.getMailtemplates(params);
        if (response?.status === 200) {
          this.templates = response.data.response;
        }
      } finally {
        this.isLoading = false;
      }
    },
    async fetchMailtemplate(template) {
      this.isLoading = true;
      try {
        const response = await mailtemplateApi.showMailtemplate(template);
        if (response?.status === 200) {
          this.template = response.data.response;
        }
      } finally {
        this.isLoading = false;
      }
    },
    async updateMailtemplate(template) {
      this.isLoading = true;
      try {
        const response = await mailtemplateApi.updateMailtemplate(template);
        return response?.status === 200;
      } finally {
        this.isLoading = false;
      }
    },
    handleEdit(template) {
      this.fetchMailtemplate(template);
    },
    async handleSubmit() {
      if (!this.template.idx) return;
      const isConfirmed = await savePopup();
      if (!isConfirmed) return;
      const isSuccess = await this.updateMailtemplate(this.template);
      if (isSuccess) {
        await this.fetchMailtemplate(this.template);
        await success();
      }
    },
    onSelect(tab) {
      if (this.currentTab !== tab) {
        this.currentTab = tab;
        this.fetchMailtemplates(
          this.templates.page_info.size,
          this.templates.page_info.page,
          this.currentTab.key
        );
      }
    },
    updateContent(newValue) {
      this.template.content = newValue;
    },
    updatePagination(pagination) {
      this.templates.page_info.size = pagination.size;
      this.templates.page_info.page = pagination.page;
      this.fetchMailtemplates(
        this.templates.page_info.size,
        this.templates.page_info.page,
        this.currentTab.key
      );
    },
  },
  mounted() {
    this.fetchMailtemplates(
      this.templates.page_info.size,
      this.templates.page_info.page,
      this.currentTab.key
    );
  },
};
</script>

<style scoped></style>
